import React, { Component } from 'react';
import { Row, Col, Card, Divider } from 'antd';
import SsStepperSteps from '../SsStepperSteps';

export default class SsStepperLayout extends Component {
    state = {
        canChangeStep: true,
        currentStep: 0,
        children: [],
        steps: new Set(),
        header: null,
        body: {
            top: null,
            bottom: null
        },
        targetStep: null
    }

    constructor(props) {
        super(props);
        if(this.props.header) this.state.header = this.props.header;
        if(this.props.body) this.state.body = this.props.body;
        this.changeStep = this.changeStep.bind(this);
    }

    getProps(p, el, i, lastStep) {
        const { currentStep, header, body } = this.state;
        return {
            state: p.state,
            currentStep: this.state.currentStep,
            lastStep: lastStep,
            hasHeader: header ? true : false,
            stepStyle: {
                top: body.top || null,
                bottom: body.bottom || null
            },
            services: p.services,
            targetStep: this.state.targetStep == null
                ? { id: el.props.id, index: i }
                : this.state.targetStep,
            controls: {
                next: this.handleNext.bind(this),
                back: this.handleBack.bind(this),
                getSteps: this.getSteps.bind(this),
                clearTargetStep: this.clearTargetStep.bind(this),
                toggleStepChange: (override) => this.toggleStepChange(override),
                targetStep: (stepData) => this.targetStep(stepData),
                updateIcon: (icon) => this.updateIcon(currentStep, icon),
                updateStatus: (status) => this.updateStatus(currentStep, status),
                updateTitle: (title) => this.updateTitle(currentStep, title),
                changeStep: this.changeStep
            }
        }
    }

    getOriginIfChanged(i) {
        let
        useOrigin = null,
        existingChild = this.state.children[i],
        originChild = this.props.children[i];

        for(let p in originChild.props) {
            if(p !== 'render') {
                if(originChild.props[p] !== existingChild.props[p]) {
                    useOrigin = true;
                    break;
                }
            }
        }

        return useOrigin ? originChild : false;
    }

    buildChildren(p, init) {
        const { currentStep, header, body } = this.state;
        let lastStep = React.Children.toArray(p.children).filter(c => c.props.id).length - 1;
        this.state.children = init
            ? React.Children.map(p.children, (el, i) => {
                this.state.steps.add(el.props.id);
                return React.cloneElement(el, this.getProps(p, el, i, lastStep));
            })
            : this.state.children.map((el, i) => {
                this.state.steps.add(el.props.id);
                let newElement = this.getOriginIfChanged(i);
                return React.cloneElement(
                    !newElement ? el : newElement,
                    this.getProps(p, el, i, lastStep)
                );
            });
    }

    buildSteps() {
        const { steps, children } = this.state;
        let _steps = [];
        steps.forEach((s) => {
            for(let i=0; i < children.length; i++) {
                if(s === children[i].props.id) {
                    _steps.push({
                        id: s || null,
                        icon: children[i].props.icon || null,
                        title: children[i].props.title || null,
                        description: children[i].props.description || null,
                        status: children[i].props.status || null
                    });
                    break;
                }
            }
        });
        return _steps;
    }

    handleNext() {
        let
        lastStep = this.state.children.length - 1,
        { currentStep } = this.state;
        this.setState({...this.state,
            currentStep: currentStep !== lastStep ? ++currentStep : lastStep
        });
    }

    handleBack() {
        let { currentStep } = this.state;
        this.setState({...this.state,
            currentStep: currentStep !== 0 ? --currentStep : 0
        });
    }

    updatedChildren(s, k, v) {
        const { targetStep } = this.state;
        s = targetStep == null ? s : targetStep.index;
        let result = [], c = this.state.children.slice();

        for(let i=0; i < c.length; i++) {
            if(i === s) result.push(React.cloneElement(c[i], { [k]: v }));
            else result.push(React.cloneElement(c[i]));
        }

        return result;
    }

    updateIcon(currentStep, icon) {
        this.state.children = this.updatedChildren(currentStep, 'icon', icon);
        if(this.state.targetStep) this.clearTargetStep();
    }

    updateStatus(currentStep, status) {
        this.state.children = this.updatedChildren(currentStep, 'status', status);
        if(this.state.targetStep) this.clearTargetStep();
    }

    updateTitle(currentStep, title) {
        this.state.children = this.updatedChildren(currentStep, 'title', title);
        if(this.state.targetStep) this.clearTargetStep();
    }

    getSteps() {
        let result = [];
        this.state.children.forEach((el, i) => {
            result.push({
                id: el.props.id,
                title: el.props.title,
                state: el.props.state[el.props.id]
            });
        });
        return result;
    }

    targetStep(step) {
        let id = null, index = null, result = null, match = false;
        if(step.id != null) id = step.id;
        if(step.index != null) index = step.index;

        for(let i=0; i < this.state.children.length; i++) {
            let t = this.state.children[i];
            if(id || index) {
                if(t.props.id === id || i === index) {
                    match = true;
                    result = { id: t.props.id, index: i };
                    break;
                }
            }
        }

        if(match) this.setState({...this.state, targetStep: result });
        else this.setState({...this.state, targetStep: null });
    }

    clearTargetStep() {
        this.setState({...this.state,
            targetStep: null
        });
    }

    changeStep(title, index) {
        if(this.state.canChangeStep) {
            if(this.state.children[index] != null)
                this.setState({...this.state, currentStep: index });
            else
                for(let i=0; i < this.state.children.length; i++) {
                    let t = this.state.children[i];
                    if(t.props.title === title) {
                        this.setState({...this.state, currentStep: i });
                        break;
                    }
                }
        }
    }

    toggleStepChange(override) {
        const { canChangeStep } = this.props;
        if(!override) {
            this.setState({...this.state, canChangeStep: !canChangeStep });
        } else {
            let s = null;
            switch(override) {
                case 'enable': s = true; break;
                case 'disable': s= false; break;
            }
            this.setState({...this.state, canChangeStep: s });
        }
    }

    componentWillMount() {
        this.buildChildren(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.buildChildren(nextProps);
    }

    render() {
        this.buildChildren(this.props);
        return (
            <div>
                {this.props.header}
                <Row
                    type='flex'
                    justify='space-around'
                    align='middle'
                    style={{
                        margin: '25px 0 25px 0'
                    }}
                >
                    <Col span={23}>
                        <SsStepperSteps
                            id={this.props.id}
                            progressDot={this.props.progressDot}
                            current={this.state.currentStep}
                            steps={this.buildSteps()}
                            changeStep={this.changeStep}
                        />
                        <Divider type='horizontal' />
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={{ margin: '5px 0 0 0' }}>
                    <Col span={24}>
                        <div className='steps-content'>
                            {this.state.children[this.state.currentStep]}
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
